const TALENT_POOL_NAMES = {
  'pt-br': 'banco de talentos',
  en: 'talent pool',
  es: 'bolsa de talentos',
}

export { TALENT_POOL_NAMES }
